import { BasketUser } from 'src/store/slices/basket-slice';

export const isBasketUserValid = (basketUserRedux: Partial<BasketUser>): boolean => {
    const requiredFields: Array<keyof BasketUser> = [
        'id',
        'first_name',
        'last_name',
        'address1',
        'address2',
        'city',
        'country',
        'nationality',
        'number',
        'phone_code',
        'post_code',
        'study_year',
        'university',
        'dob',
        'email',
        'preferred_language',
        'is_spanish_resident',
    ];

    return requiredFields.every((field) => {
        const value = basketUserRedux[field];

        return value !== undefined && value !== null && value !== '';
    });
};
